import clsx from 'clsx';
import React from 'react';

import DesktopHeaderLogo from 'images/enterprise_powerlist/enterprise-powerlist-desktop.png';
import MobileHeaderLogo from 'images/enterprise_powerlist/enterprise-powerlist-mobile.png';

import usePowerlistHeader from '../../hooks/usePowerlistHeader';
import { article_path, subscribe_promotion_path } from '../../routes';
import styles from './styles.module.css';

const PowerlistHeader = ({
  isUnlocked = true,
  offerCode,
}: {
  isUnlocked?: boolean;
  offerCode?: string;
}) => {
  const { powerlistHeader, isLoadingHeader } = usePowerlistHeader('enterprise');

  return (
    <>
      {isUnlocked && (
        <div className="row image-container">
          <div className="image-wrapper">
            <img
              srcSet={`${MobileHeaderLogo} 1500w, ${DesktopHeaderLogo} 1860w`}
              src={MobileHeaderLogo}
              height={637}
              width={1860}
              alt="top banner image"
            />
          </div>
        </div>
      )}
      {!isLoadingHeader && (
        <div className={clsx(styles.introContainer, 'row intro-container')}>
          <div className="row">
            <div className="col-sm-8 col-sm-offset-2 col-xs-10 col-xs-offset-1 intro-text-container">
              <div className={clsx(styles.introByline, 'power-byline')}>
                {powerlistHeader.byline}
              </div>
              <div className="power-description">
                {powerlistHeader.description}{' '}
                {powerlistHeader.articleSlug && (
                  <span>
                    Read the{' '}
                    <a
                      className={styles.articleLink}
                      href={article_path(powerlistHeader.articleSlug)}
                    >
                      related article
                    </a>{' '}
                    about the list and its criteria.
                  </span>
                )}
              </div>
            </div>
          </div>
          {!!isUnlocked && powerlistHeader.articleSlug && (
            <div className="row">
              <div className="article-button">
                <a href={article_path(powerlistHeader.articleSlug)}>Read The Article</a>
              </div>
            </div>
          )}
          {!isUnlocked && (
            <div className="row">
              <div className="article-button">
                <a href={subscribe_promotion_path({ offer: offerCode })}>
                  Subscribe &amp; Save $100
                </a>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default PowerlistHeader;
